import Vue from 'vue';
import moment from 'moment';
import EmailUtils from '../services/emailUtils';
import NumberHelper from "../services/numberHelper";
import {VopsUIUseLabels} from "./vopsui";
import {VopsUIUseOptions} from "./vopsui";
import {isWhiteSpace} from "../services/utils";

export class Rules {
    static get labels(): VopsUIUseLabels {
        return Vue.prototype.$vopsui.labels;
    }

    static get options(): VopsUIUseOptions {
        return Vue.prototype.$vopsui.options;
    }

    required(value: any) {
        const errorMessage = Rules.labels.fieldRequired();

        if (typeof value === "string")
            value = value.trim();

        if (Array.isArray(value))
            return value != null && value.length > 0 || errorMessage;

        return (value != null && value !== '') || errorMessage;
    }

    email(value: any) {
        return value == null || EmailUtils.isValid(value) || Rules.labels.emailMustBeValid();
    }

    url(value: any) {
        if (value == null || value === '')
            return true;
        const regex = /^(ftp|http|https):\/\/(([a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]+)|((25[0-5]|2[0-4][0-9]|[1][0-9][0-9]|[1-9][0-9]|[0-9]?)(\.(25[0-5]|2[0-4][0-9]|[1][0-9][0-9]|[1-9][0-9]|[0-9]?)){3}(:?[0-9]*)))?(\/.*)?$/;
        return regex.test(value) || Rules.labels.urlMustBeValid();
    }

    min(min: number) {
        return (value: number | string) => {
            if (value == null || value === '')
                return true;
            const number = NumberHelper.parseNumber(value, Rules.options.numberGroupSeparator(), Rules.options.numberDecimalSeparator());
            return number >= min || Rules.labels.valueMustBeMin(min.toString());
        }
    }

    max(max: number) {
        return (value: number | string) => {
            if (value == null || value === '')
                return true;
            const number = NumberHelper.parseNumber(value, Rules.options.numberGroupSeparator(), Rules.options.numberDecimalSeparator());
            return number <= max || Rules.labels.valueMustBeMax(max.toString());
        }
    }

    minLength(min: number) {
        return (value: string) => {
            if (value == null)
                return true;
            return value.length >= min || Rules.labels.lengthUnderMin(min.toString());
        }
    }

    maxLength(max: number) {
        return (value: string) => {
            if (value == null)
                return true;
            return value.length <= max || Rules.labels.lengthExceedsMax(max.toString());
        }
    }

    date(value: any) {
        return moment(value, ['YYYY-MM-DD', 'L']).isValid() || Rules.labels.invalidDate();
    }

    time(value: any) {
        return moment(value, ['HH:mm:ss', 'LT']).isValid() || Rules.labels.invalidTime();
    }

    number(value: string | number) {
        if (value == null || value === '')
            return true;

        if (isWhiteSpace(value))
            return Rules.labels.invalidNumber();

        const number = NumberHelper.parseNumber(value, Rules.options.numberGroupSeparator(), Rules.options.numberDecimalSeparator());
        return !isNaN(number as any) || Rules.labels.invalidNumber();
    }

    integer(value: any) {
        const regex = /^-?[0-9]*$/;
        return regex.test(value || '') || Rules.labels.invalidWholeNumber();
    }

    unique(existingValues: string[]) {
        return (value: string) => {
            if (existingValues == null || value == null || value === '')
                return true;
            const isUnique = existingValues.every(x => x.trim().toLowerCase() !== value.trim().toLowerCase());
            return isUnique || Rules.labels.valueAlreadyExists(value);
        }
    }

    validate(...rules: any[]) {
        return rules.every(x => x === true);
    }
}

const rules = new Rules();
export default rules;